import { z } from 'zod';
import { BaseSchema } from '../base/base.entity.model';
import * as FlatModels from '../../internal';

export enum Window {
  null = 'Standard',
  KNOCHENFENSTER = 'KF',
  LUNGENFENSTER = 'LF',
  WEICHTEILFENSTER = 'WF',
  HIRNFENSTER = 'HF',
  MAGNETRESONANZTOMOGRAPHIE_T1 = 'MRT T1',
  MAGNETRESONANZTOMOGRAPHIE_T2 = 'MRT T2',
  ANGIOGRAPHIE = 'AG',
  DIFFUSIONSGEWICHTETE_SEQUENZ = 'DGS',
  CORONARSCHNITT_1 = 'C1',
  CORONARSCHNITT_2 = 'C2',
  CORONARSCHNITT_3 = 'C3',
  SAGITTALSCHNITT_1 = 'S1',
  SAGITTALSCHNITT_2 = 'S2',
  SAGITTALSCHNITT_3 = 'S3',
  LICHTMIKROSKOPIE = 'LM',
  ELEKTRONENMIKROSKOPIE = 'EM',
  FLUORENZENZMIKROSKOPIE = 'FM'
}

export const WindowArray = Object.values(Window).map(value => { return { value: value, name: 'enum.layer.' + value }; });

export const LayerSchema = BaseSchema.extend({
  slide: z.string().uuid(),
  images: z.array(z.string().uuid()).default([]),
  window: z.nativeEnum(Window).nullable().default(null),
  default: z.boolean().nullable().default(true),
  position: z.number().default(0),
});

export type Layer = z.infer<typeof LayerSchema>;

export const LayerEntityQueryResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: LayerSchema,
});

export type LayerEntityQueryResult = z.infer<typeof LayerEntityQueryResultSchema>;
